/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ConfirmPackageImageRequest interface.
 */
export function instanceOfConfirmPackageImageRequest(value) {
    if (!('storageKey' in value) || value['storageKey'] === undefined)
        return false;
    if (!('contentType' in value) || value['contentType'] === undefined)
        return false;
    if (!('fileSizeBytes' in value) || value['fileSizeBytes'] === undefined)
        return false;
    return true;
}
export function ConfirmPackageImageRequestFromJSON(json) {
    return ConfirmPackageImageRequestFromJSONTyped(json, false);
}
export function ConfirmPackageImageRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'storageKey': json['storageKey'],
        'contentType': json['contentType'],
        'fileSizeBytes': json['fileSizeBytes'],
    };
}
export function ConfirmPackageImageRequestToJSON(json) {
    return ConfirmPackageImageRequestToJSONTyped(json, false);
}
export function ConfirmPackageImageRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'storageKey': value['storageKey'],
        'contentType': value['contentType'],
        'fileSizeBytes': value['fileSizeBytes'],
    };
}
